import { FormControlLabel, FormControlLabelProps, Switch, SwitchProps, Typography } from "@mui/material"

type SwitchBoxProps = {
	label: string
	labelPlacement?: 'start' | 'end' | 'top' | 'bottom'
	outerProps?: Omit<FormControlLabelProps, "labelPlacement" | "control" | "label">
} & SwitchProps
export const SwitchBox = ({
	label,
	labelPlacement,
	outerProps,
	...others
}: SwitchBoxProps) => {
	return (
		<FormControlLabel
			{...outerProps}
			labelPlacement={labelPlacement ?? "end"}
			control={<Switch {...others}/>}
			label={<Typography variant="caption" whiteSpace="nowrap">{label}</Typography>}
		/>
	)
}